import React, { useEffect, useRef, useState,useCallback } from "react";
import dayjs from "dayjs";
import { Storage } from "../../../../backend/storage";
import * as api from "../../../../backend/request";
import "./LicenseApplication.css";
import {
  hasUserAccess,
  getUserRole,
  getUserDetails,
} from "../../../../backend/auth";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import PageLoader from "../../../shared/PageLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link, usePath, useHistory } from "raviger";
import Table, {
  CellTmpl,
  DEFAULT_PAYLOAD,
  TitleTmpl,
  reactFormatter,
} from "../common/Table";
import {
  AUDIT_STATUS,
  MONTHS_ENUM,
  STATUS_MAPPING,
  TOOLTIP_DELAY,
} from "../../../common/Constants";
import {preventDefault} from "../../../../utils/common";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import LicenseApplicationDetail from "./LicenseApplicationDetail";
import { useGetLicenseApplications } from "../../../../backend/license";
import LicenseFilters from "../common/LicenseFilters";
import NewApplicationPanel from "./NewApplicationPanel";
import { useSidenav } from "../../../../contexts/SidenavContext";

const SortFields: any = {
  "act.name": "actn_ame",
  "rule.name": "rule_name",
  "activity.name": "activity_name",
  "activity.type": "activity_activity_type",
  "associate_company.name": "associate_company_name",
  "location.name": "location_name",
};

function getAdvanceSearch(state: any) {
  const filters = [];
  if ((state || {}).fromDate) {
    filters.push({
      columnName: "fromDate",
      value: dayjs(state.fromDate).startOf("D").toISOString(),
    });
    filters.push({
      columnName: "toDate",
      value: dayjs(state.toDate).endOf("D").toISOString(),
    });
  }

  if ((state || {}).auditType) {
    filters.push({ columnName: "auditType", value: state.auditType });
  }
  return filters.length > 0 ? filters : undefined;
}

function buildRoleBasedFilters() {
  const user = getUserDetails();
  const role = getUserRole();
  const roleFilters: any = {};

  if (role === "License Owner") {
    roleFilters.assigned_to_id_eq = user.user_id;
  }
  return roleFilters;
}

function LicenseApplication() {
  const { state }: any = useHistory();
  const { toggleSidenav } = useSidenav();
  const [checkedStatuses, setCheckedStatuses] = useState<any>(
    (state || {}).status ? { [state.status]: true } : {}
  );
  const [data, setData] = useState<any>();
  const [params, setParams] = useState<any>();
  const [locationFilters, setLocationFilter] = useState<any>();
  const lfRef: any = useRef();
  lfRef.current = locationFilters;
  const [advaceSearchFilters, setAdvanceSearchFilters] = useState(
    getAdvanceSearch(state)
  );
  const afRef: any = useRef();
  afRef.current = advaceSearchFilters;
  const [statusFilters, setStatusFilters] = useState<any>();
  const sfRef = useRef();
  sfRef.current = statusFilters;
  const [roleFilters] = useState<any>(buildRoleBasedFilters());
  const rfRef = useRef();
  rfRef.current = roleFilters;
  const [payload, setPayload] = useState<any>();
  const payloadRef = useRef();
  payloadRef.current = payload;
  const { applications, total, isFetching, refetch, companyIds } = useGetLicenseApplications(
    payload,
    Boolean(payload)
  );
 
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [previousFilters, setPreviousFilters] = useState<any>({});
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [isLicenseDetailOpen, setLicenseDetailOpen] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState<any>(null);

  const onLocationChange = useCallback((filters: any) => {
    setLocationFilter(filters);

    const _params = {
      ...params,
      page: 1,
      filters: {
        ...(rfRef.current || {}),
        // ...filters,
        ...(sfRef.current || {}),
      },
    };
    setParams(_params);
    setPayload(_params);
    setPreviousFilters(filters);
  }, [params]);


  useEffect(() => {
    checkFirstTimePublish();
  }, [applications]);

  function checkFirstTimePublish() {
    const { month_eq, year_eq } = getAdvanceSearchPayload();
    if (month_eq && year_eq) {
      const _filter = {
        ...previousFilters,
      };
      const date = new Date();
      date.setDate(1);
      date.setFullYear(parseInt(`${year_eq}`));
      date.setMonth(MONTHS_ENUM.indexOf(month_eq));
      _filter["monthYear"] = date;
      setPreviousFilters(_filter);
    }
  }

  function StatusTmpl({ cell }: any) {
    const status = cell.getValue() || "";
    const statusLower = status.toLowerCase();

    let colorClass = "";
    let displayStatus = status.replace(/_/g, " ");

    if (statusLower.includes("not_started")) {
      colorClass = "not_started";
    } else if (statusLower.includes("docs_pending")) {
      colorClass = "renewal";
    } else if (statusLower.includes("rejected")) {
      colorClass = "expired";
    } else if (statusLower.includes("expired")) {
      colorClass = "expired";
    } else if (statusLower.includes("application_approved")) {
      colorClass = "active";
    } else if (statusLower.includes("pending_at_authority")) {
      colorClass = "renewal";
    } else if (statusLower.includes("commercials_pending")) {
      colorClass = "renewal";
    }

    return (
      <span className={`text-capitalize color-class fw-bold ${colorClass}`}>
        {displayStatus}
      </span>
    );
  }


  function ActionsTmpl({ cell }: any) {
    const row = cell.getData();
    return (
      <div className="cursor-pointer">
        <div 
          onClick={() => {
            toggleSidenav(false);
            setSelectedApplication(row);
            setLicenseDetailOpen(true);
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M0.666626 8.65627C0.666626 8.65627 3.33329 3.32294 7.99996 3.32294C12.6666 3.32294 15.3333 8.65627 15.3333 8.65627C15.3333 8.65627 12.6666 13.9896 7.99996 13.9896C3.33329 13.9896 0.666626 8.65627 0.666626 8.65627Z" stroke="#2965AD" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7.99996 10.6563C9.10453 10.6563 9.99996 9.76084 9.99996 8.65627C9.99996 7.5517 9.10453 6.65627 7.99996 6.65627C6.89539 6.65627 5.99996 7.5517 5.99996 8.65627C5.99996 9.76084 6.89539 10.6563 7.99996 10.6563Z" stroke="#2965AD" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    );
  }

  const columns = [
    {
      title: "IDs", // application id
      field: "id",
      //width: 150,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      headerClick: (e: any, col: any) => {
        preventDefault(e);
      },
    },
    {
      title: "License Name",
      field: "license_name",
      //width: 150,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "License Type",
      field: "license_type.name",
      //width: 150,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Application Type", // action_type( application type)
      field: "application_type.action_type",
      //width: 150,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "License Reference",
      field: "license_reference.license_name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      //width: 150,
    },
    {
      title: "Status",
      field: "status",
      formatter: reactFormatter(<StatusTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      //width: 150,
    },
    {
      title: "Actions", // view details option
      field: "actions",
      formatter: reactFormatter(<ActionsTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      //width: 150,
    },
  ];

  const [tableConfig] = useState({
    paginationMode: "remote",
    ajaxRequestFunc,
    columns,
    rowHeight: "auto",
    // selectable: getUserRole() === "Vendor User" ? true : false,
    selectable: hasUserAccess(USER_PRIVILEGES.CREATE_AND_EDIT_LICENSE_APPLICATION),
    paginate: true,
    // initialSort: ["month desc"],
    rowFormatter,
  });

  function rowFormatter(row: any) {
    const data = row.getData();
    const element = row.getElement();
  }

  function formatApiResponse(params: any, list: any, totalRecords: number) {
    const { page, per } = params || {};
    const tdata = {
      data: list,
      total: totalRecords,
      last_page: Math.ceil(totalRecords / (per || 1)) || 1,
      page: page || 1,
    };
    return tdata;
  }

  function hasFilters(ref: any, field = "company_id_eq") {
    const _filters: any =
      (ref
        ? ref.current
        : ({ ...(payloadRef.current || {}) } as any)["filters"]) || {};
    return _filters[field];
  }

  function ajaxRequestFunc(url: any, config: any, params: any) {
    const { field, dir } = (params.sort || [])[0] || {};
    const _params = {
      per: params.size,
      page: params.page,
      include: [
       "company",
       "associate_company",
       "location",
       "license_type",
       "application_type",
       "state",
       "city",
       "assigned_to",
       "requested_by",
       "license_reference",
      ],
      includes: [
       "company",
       "associate_company",
       "location",
       "license_type",
       "application_type",
       "state",
       "city",
       "assigned_to",
       "requested_by",
       "license_reference"
      ],
      methods: ["watcher_names"],
      sorts: [`${field || "created_at"} ${dir || "desc"}`],
    };
    setParams(_params);
    setPayload({
      ...DEFAULT_PAYLOAD,
      ..._params,
      filters: {
        ...(rfRef.current || {}),
        ...(lfRef.current || {}),
        ...(sfRef.current || {}),
      },
    });
    return Promise.resolve(formatApiResponse(params, applications || [], total || 0));
  }

  function handlePageNav(_pagination: any) {
    const _params = {
      ...params,
      ..._pagination,
      filters: {
        ...(rfRef.current || {}),
        ...(lfRef.current || {}),
        ...(afRef.current || {}),
        ...(sfRef.current || {}),
      }
    };
    setParams({ ..._params });
    setPayload({ ..._params });
  }

  function getAdvanceSearchPayload() {
    return { ...(afRef.current || {}) };
  }

  // Initialize payload on mount to load all applications
  useEffect(() => {
    const initialPayload = {
      ...DEFAULT_PAYLOAD,
      page: 1,
      per: 10,
      sorts: ["created_at desc"],
      include: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "state",
        "city",
        "assigned_to",
        "requested_by",
        "license_reference",
      ],
      includes: [
        "company",
        "associate_company",
        "location",
        "license_type",
        "application_type",
        "state",
        "city",
        "assigned_to",
        "requested_by",
        "license_reference",
      ],
      methods: ["watcher_names"],
      filters: buildRoleBasedFilters()
    };
    setParams(initialPayload);
    setPayload(initialPayload);
  }, []);

  useEffect(() => {
    if (locationFilters) {
      const _params = { ...params, page: 1 };
      setParams({ ..._params });
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        ..._params,
        sorts: payload.sorts || ["created_at desc"],
        include: [
          "company",
          "associate_company",
          "location",
          "license_type",
          "application_type",
          "state",
          "city",
          "assigned_to",
          "requested_by",
          "license_reference",
        ],
        includes: [
          "company",
          "associate_company",
          "location",
          "license_type",
          "application_type",
          "state",
          "city",
          "assigned_to",
          "requested_by",
          "license_reference",
        ],
        methods: ["watcher_names"],
        filters: {
          ...(rfRef.current || {}),
          ...locationFilters,
          ...(afRef.current || {}),
          ...(sfRef.current || {}),
        },
      });
    }
  }, [locationFilters]);

  useEffect(() => {
    if (locationFilters) {
      const _params = { ...params, page: 1 };
      setParams({ ..._params });
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        ..._params,
        sorts: payload.sorts || ["created_at desc"],
        include: [
          "company",
          "associate_company",
          "location",
          "license_type",
          "application_type",
          "state",
          "city",
          "assigned_to",
          "requested_by",
          "license_reference",
        ],
        includes: [
          "company",
          "associate_company",
          "location",
          "license_type",
          "application_type",
          "state",
          "city",
          "assigned_to",
          "requested_by",
          "license_reference",
        ],
        methods: ["watcher_names"],
        filters: {
          ...(rfRef.current || {}),
          ...(lfRef.current || {}),
          ...(advaceSearchFilters || {}),
          ...(sfRef.current || {}),
        },
      });
    }
  }, [advaceSearchFilters]);

  useEffect(() => {
    if (locationFilters) {
      const _params = { ...params, page: 1 };
      setParams({ ..._params });
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        ..._params,
        sorts: payload.sorts || ["created_at desc"],
        include: [
          "company",
          "associate_company",
          "location",
          "license_type",
          "application_type",
          "state",
          "city",
          "assigned_to",
          "requested_by",
          "license_reference",
        ],
        includes: [
          "company",
          "associate_company",
          "location",
          "license_type",
          "application_type",
          "state",
          "city",
          "assigned_to",
          "requested_by",
          "license_reference",
        ],
        methods: ["watcher_names"],
        filters: {
          ...(rfRef.current || {}),
          ...(lfRef.current || {}),
          ...(afRef.current || {}),
          ...(statusFilters || {}),
        },
      });
    }
  }, [statusFilters]);

  useEffect(() => {
    if (checkedStatuses) {
      const keys = Object.keys(checkedStatuses);
      const result = keys.filter((key) => !!checkedStatuses[key]);
      const _result: any = {};
      if (result.length > 0) {
        _result["status_in"] = result;
      }
      setStatusFilters(_result);
    }
  }, [checkedStatuses]);

  useEffect(() => {
    if (!isFetching && payload) {
      setSelectedRows([]);
      setData(formatApiResponse(params, applications || [], total || 0));
    }
  }, [isFetching]);

  return (
    <>
      <div className="licenseapplication-wrapper">
        <div className="d-flex flex-column license-dashboard">
          <div className="d-flex p-3 align-items-center pageHeading">
            <div>
              <h4 className="mb-0">License Applications</h4>
              {(getUserRole() === "License Manager" || getUserRole() === "License Owner" ) ? <p>
                Apply and track license applications across all companies, associate companies, and locations.
              </p> : <p>
                Check and oversee all licenses applied across companies, associate companies, and locations. 
              </p>}
            </div>
            <div className="d-flex align-items-end h-100">
              {/* <button className="button-primary" onClick={() => setIsSidePanelOpen(true)}>New Application</button> */}
              {getUserRole() === "License Manager" && hasUserAccess(USER_PRIVILEGES.CREATE_AND_EDIT_LICENSE_APPLICATION) && (
                <button className="button-primary" onClick={() => {
                  toggleSidenav(false);
                  setIsSidePanelOpen(true);
                }}>Create New Application</button>
              )}
            </div>
          </div>

          <form className="p-0 mx-3">
            <div className="card border-0 py-4 px-2">
              <div className="d-flex flex-row filters">
                <LicenseFilters onChange={onLocationChange} />
              </div>
            </div>
          </form>
          <div className="position-relative p-3 pb-0 license-table license-application-table">
            <Table
              data={data}
              options={tableConfig}
              isLoading={isFetching}
              onSelectionChange={setSelectedRows}
              onPageNav={handlePageNav}
            />
          </div>
        </div>
        {/* {(submitting) && <PageLoader />} */}
        <NewApplicationPanel
          isOpen={isSidePanelOpen}
          closePanel={() => setIsSidePanelOpen(false)}
          onSuccess={() => {
              refetch();
              setIsSidePanelOpen(false);
          }}
        />
        <LicenseApplicationDetail
          isOpen={isLicenseDetailOpen}
          closePanel={() => {
            setLicenseDetailOpen(false);
            setSelectedApplication(null);  
          }}
          license={selectedApplication}
          refetch={refetch}
        />
      </div>
      {isFetching && <PageLoader />}
    </>
  );
}

export default LicenseApplication;
